import React from "react";
import { IconArrowUp } from "../../utils/icons";

interface Props {
  count: number;
  label: string;
  canLoadPrevious?: boolean;
  hasMore?: boolean;
  onLoadPrevious?: () => void;
  className?: string;
}

export function PageDivider({ count, label, canLoadPrevious, hasMore, onLoadPrevious, className }: Props) {
  return (
    <div className={`flex items-center gap-2 ${className ?? ""}`}>
      <div className="text-text-2 shrink-0 whitespace-nowrap pr-2">
        {count} {label}
      </div>
      <div className="border-t w-full border-border-token" />
      {canLoadPrevious && onLoadPrevious && (
        <div
          onClick={onLoadPrevious}
          className="ml-2 flex items-center justify-center w-8 h-8 rounded-full bg-accent cursor-pointer shrink-0"
        >
          {/* stroke is an SVG presentation attribute (no var()); white on the gold fill in both themes */}
          <IconArrowUp stroke="#fff" width={20} height={20} />
        </div>
      )}
    </div>
  );
}
